import validator from 'validator'

import {
  normalizeIntValue,
  normalizeStringValue,
} from '../../../../../helpers/normalizers'

import challenges from '../options/challenges.json'
import challengesGroups from '../options/challenges_groups.json'

export default {
  applicant_team_number: {
    label: 'Número da sua equipe (no Discord) *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_team_number,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_proposal_challenge: {
    label: 'Qual é a temática da sua solução? *',
    initialValue: '',
    options: challenges,
    parseRegistration(registrationData) {
      return normalizeIntValue(
        registrationData.extra_data.applicant_proposal_challenge,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_proposal_challenge_group: {
    label:
      'Qual é seu agrupamento da temática? (Se você não sabe qual é seu grupo, confira dentro do Discord no canal #qual-meu-tema de acordo com o número da sua equipe). *',
    initialValue: '',
    options: challengesGroups,
    parseRegistration(registrationData) {
      return normalizeIntValue(
        registrationData.extra_data.applicant_proposal_challenge_group,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_proposal_name: {
    label: 'Nome da sua solução criada *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_proposal_name,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_name: {
    label: 'Nome do integrante 1 *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.full_name)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_email: {
    label: 'E-mail do integrante 1 *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.email)
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      if (!validator.isEmail(formData[fieldId])) {
        return { [fieldId]: 'invalid' }
      }
      return {}
    },
  },
  applicant_b_name: {
    label: 'Nome do integrante 2',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_b_name)
    },
  },
  applicant_b_email: {
    label: 'E-mail do integrante 2',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_b_email)
    },
    validate(fieldId, formData) {
      if (!validator.isEmpty(formData[fieldId])) {
        if (!validator.isEmail(formData[fieldId])) {
          return { [fieldId]: 'invalid' }
        }
      }
      return {}
    },
  },
  applicant_c_name: {
    label: 'Nome do integrante 3',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_c_name)
    },
  },
  applicant_c_email: {
    label: 'E-mail do integrante 3',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_c_email)
    },
    validate(fieldId, formData) {
      if (!validator.isEmpty(formData[fieldId])) {
        if (!validator.isEmail(formData[fieldId])) {
          return { [fieldId]: 'invalid' }
        }
      }
      return {}
    },
  },
  applicant_d_name: {
    label: 'Nome do integrante 4',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_d_name)
    },
  },
  applicant_d_email: {
    label: 'E-mail do integrante 4',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_d_email)
    },
    validate(fieldId, formData) {
      if (!validator.isEmpty(formData[fieldId])) {
        if (!validator.isEmail(formData[fieldId])) {
          return { [fieldId]: 'invalid' }
        }
      }
      return {}
    },
  },
  applicant_e_name: {
    label: 'Nome do integrante 5',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_e_name)
    },
  },
  applicant_e_email: {
    label: 'E-mail do integrante 5',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_e_email)
    },
    validate(fieldId, formData) {
      if (!validator.isEmpty(formData[fieldId])) {
        if (!validator.isEmail(formData[fieldId])) {
          return { [fieldId]: 'invalid' }
        }
      }
      return {}
    },
  },
  applicant_f_name: {
    label: 'Nome do integrante 6',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_f_name)
    },
  },
  applicant_f_email: {
    label: 'E-mail do integrante 6',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(registrationData.extra_data.applicant_f_email)
    },
    validate(fieldId, formData) {
      if (!validator.isEmpty(formData[fieldId])) {
        if (!validator.isEmail(formData[fieldId])) {
          return { [fieldId]: 'invalid' }
        }
      }
      return {}
    },
  },
}
